import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useSelector } from 'react-redux';
import { T, useTranslate } from 'shared/helper/translate';
import Link from 'shared/components/Link';
import { getChinaLocalization } from 'shared/account/reducer';
import Popover from 'researcher/components/Popover';
import featureEnabled from 'shared/helper/feature';
import { getTranslationStatus } from '../reducer';
import { formatForLocale } from '../helpers/date';
export var RubriqTranslationStatusTooltip = function RubriqTranslationStatusTooltip() {
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector.curie,
    plans = _useSelector.curie.plans;
  var _getTranslationStatus = getTranslationStatus({
      curie: curie
    }),
    hasActiveTrial = _getTranslationStatus.hasActiveTrial,
    hasPremiumTrial = _getTranslationStatus.hasPremiumTrial,
    hasPremiumTranslations = _getTranslationStatus.hasPremiumTranslations,
    premiumTranslationsRemaining = _getTranslationStatus.premiumTranslationsRemaining,
    premiumTranslationsRenewalDate = _getTranslationStatus.premiumTranslationsRenewalDate,
    hasPreferredGroup = _getTranslationStatus.hasPreferredGroup,
    hasPreferredGroupTranslations = _getTranslationStatus.hasPreferredGroupTranslations,
    groupTranslationsProvisioned = _getTranslationStatus.groupTranslationsProvisioned,
    groupTranslationsRemaining = _getTranslationStatus.groupTranslationsRemaining,
    deepSeekEnabled = _getTranslationStatus.deepSeekEnabled,
    translationsRemaining = _getTranslationStatus.translationsRemaining;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var getStatusTooltip = function getStatusTooltip() {
    var _plans$premium, _plans$premium2;
    if (((_plans$premium = plans.premium) === null || _plans$premium === void 0 ? void 0 : _plans$premium.planName) === 'premium_editing_only' || ((_plans$premium2 = plans.premium) === null || _plans$premium2 === void 0 ? void 0 : _plans$premium2.planName) === 'premium_editing_only_no_trial') {
      return 'paid-subscription-translations-not-available-content';
    }
    if (hasPremiumTrial) {
      return 'curie.paid-subscription-translations-available-date';
    }
    if (hasPremiumTranslations && hasPreferredGroupTranslations) {
      if (deepSeekEnabled && premiumTranslationsRemaining > 0) {
        return 'rubriq.group-and-plan-unlimited-chineese-translation-tooltip';
      }
      if (premiumTranslationsRemaining > 0) {
        return 'curie.group-and-unused-premium-access-translation-tooltip';
      }
      if (deepSeekEnabled) {
        return 'rubriq.group-and-plan-unlimited-chineese-translation-tooltip'; // rubriq.group-and-plan-unlimited-chineese-translation-tooltip
      }
      return 'curie.group-and-used-premium-access-translation-tooltip';
    }
    if (premiumTranslationsRemaining > 0 && deepSeekEnabled) {
      if (translationsRemaining > 0) {
        return 'tooltip-unlimited-translations';
      }
      return 'curie.premium-access-used-translation-tooltip';
    }
    if (hasPremiumTranslations) {
      if (premiumTranslationsRemaining > 0) {
        return 'curie.premium-access-unused-translation-tooltip';
      }
      if (deepSeekEnabled) {
        return 'tooltip-unlimited-translations';
      }
      return 'curie.premium-access-used-translation-tooltip';
    }
    if (hasPreferredGroupTranslations && deepSeekEnabled) {
      if (groupTranslationsRemaining > 0) {
        return 'tooltip-unlimited-translations';
      }
    }
    if (hasPreferredGroupTranslations) {
      return 'curie.translation-preferred-group-access-translation-tooltip';
    }
    if (hasActiveTrial) {
      return 'curie.trial-access-translation-tooltip';
    }
    if (hasPreferredGroup) {
      return 'curie.preferred-group-access-translation-tooltip';
    }
    return 'curie.no-features-translation-tooltip';
  };
  var getStatusTooltipParams = function getStatusTooltipParams() {
    if (hasPremiumTrial) {
      return formatForLocale(premiumTranslationsRenewalDate, t);
    }
    if (hasPremiumTranslations && hasPreferredGroupTranslations) {
      if (deepSeekEnabled && premiumTranslationsRemaining > 0) {
        return {
          premiumCount: premiumTranslationsRemaining,
          groupCount: groupTranslationsRemaining
        };
      }
      if (deepSeekEnabled) {
        return {
          premiumCount: premiumTranslationsRemaining,
          groupCount: groupTranslationsRemaining
        };
      }
      return {
        groupTranslationsProvisioned: groupTranslationsProvisioned
      };
    }
    if (hasPremiumTranslations && premiumTranslationsRemaining > 0 && deepSeekEnabled && translationsRemaining > 0) {
      return {
        count: translationsRemaining
      };
    }
    if (hasPremiumTranslations) {
      if (deepSeekEnabled) {
        return {
          count: translationsRemaining
        };
      }
      return formatForLocale(premiumTranslationsRenewalDate, t);
    }
    if (hasPreferredGroupTranslations && deepSeekEnabled && groupTranslationsRemaining > 0) {
      return {
        count: groupTranslationsRemaining
      };
    }
    if (hasPreferredGroupTranslations) {
      return {
        groupTranslationsRemaining: groupTranslationsRemaining
      };
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(Popover, {
    content: getStatusTooltip(),
    params: getStatusTooltipParams(),
    "data-bs-toggle": "tooltip",
    "data-bs-placement": "bottom"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-light fa-circle-info"
  }));
};
var RubriqTranslationStatus = function RubriqTranslationStatus(_ref) {
  var _ref$isNoTranslations = _ref.isNoTranslationsMessage,
    isNoTranslationsMessage = _ref$isNoTranslations === void 0 ? false : _ref$isNoTranslations;
  var _useSelector2 = useSelector(function (state) {
      return state;
    }),
    curie = _useSelector2.curie;
  var _getTranslationStatus2 = getTranslationStatus({
      curie: curie
    }),
    hasPremiumTranslations = _getTranslationStatus2.hasPremiumTranslations,
    translationUsesRemaining = _getTranslationStatus2.translationUsesRemaining,
    hasPreferredGroup = _getTranslationStatus2.hasPreferredGroup,
    hasPremiumTrial = _getTranslationStatus2.hasPremiumTrial,
    editingOnlyPlan = _getTranslationStatus2.editingOnlyPlan,
    cancelledDuringTrial = _getTranslationStatus2.cancelledDuringTrial,
    premiumWithTranslationsPlan = _getTranslationStatus2.premiumWithTranslationsPlan,
    deepSeekEnabled = _getTranslationStatus2.deepSeekEnabled;
  var hasCheckIcon = translationUsesRemaining > 0;
  var noPremiumOrGroup = !hasPremiumTranslations && !hasPreferredGroup;
  var noTrialOrEditingOnly = !hasPremiumTrial && !editingOnlyPlan;
  var notCancelledTrialWithTranslation = !(cancelledDuringTrial && premiumWithTranslationsPlan);
  var hasLink = noPremiumOrGroup && noTrialOrEditingOnly && notCancelledTrialWithTranslation;
  var isChinaUser = useSelector(getChinaLocalization);
  var paddleBillingForChina = featureEnabled('rubriq_china_also_uses_paddle');
  var useCartInsteadOfPaddle = isChinaUser && !paddleBillingForChina;
  var subscriptionRoute = useCartInsteadOfPaddle ? '/rubriq/plan/subscribe' : '/rubriq/plan/subscribe/premium';
  var getStatusText = function getStatusText() {
    if (translationUsesRemaining > 0) {
      return deepSeekEnabled ? 'translations available' : '%s translations available';
    }
    return deepSeekEnabled && hasPremiumTranslations && !hasPremiumTrial ? 'translations available' : 'no translations available';
  };
  var getStatusTextParams = function getStatusTextParams() {
    if (translationUsesRemaining > 0) {
      return translationUsesRemaining;
    }
    return null;
  };
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2 flex-md-row gap-md-3 ".concat(isNoTranslationsMessage ? 'align-items-center' : 'align-items-start align-items-md-center')
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-2"
  }, hasCheckIcon && /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-solid fa-check"
  }), /*#__PURE__*/React.createElement(T, {
    source: getStatusText(),
    params: getStatusTextParams()
  }), /*#__PURE__*/React.createElement(RubriqTranslationStatusTooltip, null)), hasLink && /*#__PURE__*/React.createElement(Link, {
    className: hasCheckIcon && !isNoTranslationsMessage ? 'ms-2 ms-md-0 rubriq-status-link' : '',
    to: subscriptionRoute
  }, /*#__PURE__*/React.createElement(T, {
    source: "upgrade-now"
  })));
};
export default RubriqTranslationStatus;